import { DownloadSimpleIcon } from "@phosphor-icons/react/DownloadSimple";
import { useState } from "react";
import { useShipmentService } from "@/Services/ShipmentService";
import ProgressSpinner from "@/Shared/Icons/ProgressSpinner";
import { ProgressSpinnerSizes } from "@/Shared/Icons/ProgressSpinnerSizes";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface DownloadQuotePdfProps {
  quoteId: string;
}

function QuotesDownloadQuotePdf(props: DownloadQuotePdfProps) {
  const [isDownloading, setIsDownloading] = useState(false);
  const { downloadQuote } = useShipmentService();

  async function handleDownloadQuote() {
    try {
      setIsDownloading(true);
      await downloadQuote(props.quoteId);
    } catch (error) {
      console.error("Error downloading quote:", error);
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <Button size="link" inheritFont onClick={handleDownloadQuote}>
      <div className="flex flex-row items-center">
        {isDownloading ? (
          <ProgressSpinner size={ProgressSpinnerSizes.Small} />
        ) : (
          <DownloadSimpleIcon
            className="h-5 w-5"
            weight="fill"
            style={{ color: "var(--color-blue)" }}
          />
        )}
        <div className="w-[4px] shrink-0" />
        <span>Download Quote as PDF</span>
      </div>
    </Button>
  );
}

export default QuotesDownloadQuotePdf;
